import { baseApi } from "../../services/rtkApi/baseApi";

// GET /api/prints/files (admin): the print-ready files by batch. Every url in the answer is a
// signed link that stops working at linksExpireAt (an hour), so the page asks again before then.

export interface PrintFile {
  name: string;
  path: string;
  size: number;
  about: string;
  pages: number | null;
  url: string;
  thumbUrl: string | null;
}

export interface PrintBatch {
  id: string;
  title: string;
  summary: string;
  createdAt: string;
  fileCount: number;
  totalSize: number;
  readme: { name: string; text: string; url: string } | null;
  zip: { name: string; size: number; url: string } | null;
  groups: { title: string; files: PrintFile[] }[];
}

export interface PrintFilesListing {
  batches: PrintBatch[];
  linksExpireAt: string;
}

const printFilesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // `key` only makes each refresh its own request; the server reads `refresh`
    getPrintFiles: builder.query<PrintFilesListing, { refresh?: boolean; key?: number } | void>({
      query: (arg) => (arg && arg.refresh ? "/prints/files?refresh=1" : "/prints/files"),
      // the links expire, so never hand out an old answer from a while ago
      keepUnusedDataFor: 30,
    }),
  }),
});

export const { useGetPrintFilesQuery, useLazyGetPrintFilesQuery } = printFilesApi;
